import Vue from 'vue'
import Router from 'vue-router'
import AcquiringAbout from '@/components/AcquiringAbout'
import AcquiringDemoProducts from '@/components/AcquiringDemoProducts'
import AcquiringDocuments from '@/components/AcquiringDocuments'
import AcquiringPaymentInfo from '@/components/AcquiringPaymentInfo'
import AcquiringPaymentResult from '@/components/AcquiringPaymentResult'
import BalanceOperationList from '@/components/BalanceOperationList'
import BuyoutItem from '@/components/BuyoutItem'
import BuyoutPickupPointSet from '@/components/BuyoutPickupPointSet'
import EventList from '@/components/EventList'
import MessagePermissions from '@/components/MessagePermissions'
import ErrorNeedPay from '@/components/ErrorNeedPay'
import Payment from '@/components/Payment'
import PaymentConfirmation from '@/components/PaymentConfirmation'
import SourceContent from '@/components/SourceContent'
import SourceSelector from '@/components/SourceSelector'
import SourceSettings from '@/components/SourceSettings'
import UserProfile from '@/components/UserProfile'
import UserProfileSourceContext from '@/components/UserProfileSourceContext'
import {appStates} from '@/constants'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err) //catch push error for duplicate state
};

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: appStates.acquiringAbout.path,
            name: appStates.acquiringAbout.name,
            component: AcquiringAbout
        }, {
            path: appStates.acquiringDemoProducts.path,
            name: appStates.acquiringDemoProducts.name,
            component: AcquiringDemoProducts
        }, {
            path: appStates.acquiringDocuments.path,
            name: appStates.acquiringDocuments.name,
            component: AcquiringDocuments
        }, {
            path: appStates.acquiringPaymentInfo.path,
            name: appStates.acquiringPaymentInfo.name,
            component: AcquiringPaymentInfo
        }, {
            path: appStates.acquiringPaymentResult.path,
            name: appStates.acquiringPaymentResult.name,
            component: AcquiringPaymentResult
        }, {
            path: appStates.sourceList.path,
            name: appStates.sourceList.name,
            component: SourceSelector
        }, {
            path: appStates.sourceItemContent.path,
            name: appStates.sourceItemContent.name,
            component: SourceContent
        }, {
            path: appStates.sourceItemEventList.path,
            name: appStates.sourceItemEventList.name,
            component: EventList
        }, {
            path: appStates.sourceItemBuyoutItem.path,
            name: appStates.sourceItemBuyoutItem.name,
            component: BuyoutItem
        }, {
            path: appStates.buyoutBalance.path,
            name: appStates.buyoutBalance.name,
            component: BalanceOperationList,
            props: true
        }, {
            path: appStates.buyoutPayment.path,
            name: appStates.buyoutPayment.name,
            component: Payment
        }, {
            path: appStates.buyoutPaymentConfirmation.path,
            name: appStates.buyoutPaymentConfirmation.name,
            component: PaymentConfirmation
        }, {
            path: appStates.buyoutPickupPointSet.path,
            name: appStates.buyoutPickupPointSet.name,
            component: BuyoutPickupPointSet
        }, {
            path: appStates.needPay.path,
            name: appStates.needPay.name,
            component: ErrorNeedPay
        }, {
            path: appStates.sourceItemSettings.path,
            name: appStates.sourceItemSettings.name,
            component: SourceSettings
        }, {
            path: appStates.sourceItemUserProfile.path,
            name: appStates.sourceItemUserProfile.name,
            component: UserProfileSourceContext
        }, {
            path: appStates.userProfile.path,
            name: appStates.userProfile.name,
            component: UserProfile
        }, {
            path: appStates.messagePermissions.path,
            name: appStates.messagePermissions.name,
            component: MessagePermissions
        }
    ]
})

export default router
